import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  // デバウンス送信（テキスト入力用、300ms遅延）
  submit() {
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300)
  }

  // 即時送信（セレクト・日付フィールド用）
  submitNow() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.requestSubmit()
  }
}
